import {gql} from "@apollo/client";

export const GET_JOB_STEPS = gql`
	query getJobSteps ($filter: JobStepFilterInput) {
		jobSteps (where: $filter) {
			 nodes {
				id
				description
				concurrency
				order
				inputStep {
					id
				}
				jobSettings {
					id
				}
				customSettings
				processor
				startMode
			}
		}
	}
`;
